var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center w-100"},[(_vm.show)?_c('div',{staticClass:"d-flex preloader-wrapper justify-content-center align-items-center h-100 w-100"},[_c('div',{staticClass:"d-flex preloader animated fadeIn"})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1869a3ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Preloader.vue
// module id = 1037
// module chunks = 1